import { useGo, useParsed } from '@refinedev/core';
import useWorkspace from './useWorkspace';

// this will provide the PanelContext;
export default function useProject() {
  const { params } = useParsed();
  const [workspaceId] = useWorkspace();
  const projectId = params?.projectId;
  const goTo = useGo();
  const setProject = (value: string) => {
    goTo({
      to: `/${workspaceId}/${value}`,
      type: 'push',
    });
  };

  return [projectId, setProject];
}
